module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("common_model_profile_notices", [["div",{"class":"gui-notice-block &&0&& fill-all-b animatedCSS3 fadeInDown","notice-alias":""},[["p",{"class":"message"},[["textNode",{"text":" "}],["span",{},[],[["message","__text",true]]],["textNode",{"text":" "}]]]],[["type","class"],["alias","notice-alias",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/sitepage/profile/notices.tpl
// module id = 267
// module chunks = 2